// packages/web/src/components/ui/Alert.tsx — misma API.
import type { ReactNode } from 'react';
import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react';

type Kind = 'error' | 'warn' | 'info' | 'success';

const STYLE: Record<Kind, { wrapper: string; Icon: typeof AlertCircle }> = {
  error: { wrapper: 'bg-red-50 text-red-800 border-red-200', Icon: AlertCircle },
  warn: { wrapper: 'bg-amber-50 text-amber-900 border-amber-200', Icon: AlertTriangle },
  info: { wrapper: 'bg-marzano-50 text-marzano-800 border-marzano-100', Icon: Info },
  success: { wrapper: 'bg-emerald-50 text-emerald-800 border-emerald-200', Icon: CheckCircle2 },
};

export function Alert({ kind, children, className = '' }: { kind: Kind; children: ReactNode; className?: string }) {
  const { wrapper, Icon } = STYLE[kind];
  return (
    <div role={kind === 'error' ? 'alert' : 'status'} className={`${wrapper} border px-3.5 py-3 rounded-lg text-sm flex gap-2.5 items-start ${className}`}>
      <Icon aria-hidden className="w-4 h-4 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0 leading-relaxed">{children}</div>
    </div>
  );
}
